/**
 * @generated SignedSource<<ff9e72a4f93572a62fc26f7ceab2dfc4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paymentInInlineFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly ref: string;
  readonly amount: number;
  readonly currencyCode: string;
  readonly payerEmail: string;
  readonly meta: any | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "paymentInInlineFragment";
};
export type paymentInInlineFragment$key = {
  readonly " $data"?: paymentInInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"paymentInInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paymentInInlineFragment"
};

(node as any).hash = "fee6f0f152497c74f4b795651592726f";

export default node;
